import React, { useState } from 'react'
import CheckBox from '../../../../../common/CheckBox'

const CreateDtcMappingsCheckbox = ({
  title,
  field,
  checked,
  onChange,
  isDark = true,
}) => {
  const [createDtcMappings, setCreateDtcMappings] = useState(checked || false)

  return (
    <span className="flex pt-4 items-center">
      <CheckBox
        name={field}
        value={createDtcMappings}
        checked={createDtcMappings}
        onChange={(e) => {
          setCreateDtcMappings(e.target.checked)
          onChange(e.target.checked)
        }}
      />
      <span className={`pl-2 ${isDark ? 'text-white' : ''}`}>{title}</span>
    </span>
  )
}

export default CreateDtcMappingsCheckbox
